import { useIntl } from 'react-intl';
import { IconLock } from '@rossum/ui/icons/tabler';
import { Stack, SvgIcon, Typography } from '@rossum/ui/material';

export const DataCaptureLockedBanner = () => {
  const intl = useIntl();

  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      justifyContent="center"
      sx={{
        backgroundColor: theme => theme.palette.error.light,
        py: 0.5,
        height: '32px',
      }}
      data-cy="data-capture-locked-banner"
    >
      <SvgIcon fontSize="medium">
        <IconLock />
      </SvgIcon>
      <Typography variant="body2">
        {intl.formatMessage({
          id: 'components.announcements.dataCaptureLocked.text',
        })}
      </Typography>
    </Stack>
  );
};
